module.exports = __webpack_public_path__ + "static/media/mbys_cou.bfff6ef3.png";